import { StopSvg } from '../svg/stop-svg'
import { Lang } from '../../translations/lang'

export const NgIcon = () => (
  <span className="inline-flex flex-col justify-between items-center gap-[4px]">
    <StopSvg />
    <span className="text-xs font-bold text-vixell-red">{Lang.ng}</span>
  </span>
)
